/**
 * 서버가 폴더 관련 요청을 거절할 때 쓰는 코드(`ZepQuizApiError.status`).
 * 화면이 직접 잡아야 하는 것들만 모았다.
 *
 * 확인값은 미리 계산하지 않는다. 확인값 없이 보내고 `*_CONFIRM_REQUIRED` 가 오면 안내한 뒤
 * 같은 요청을 확인값 `true` 로 한 번만 재전송한다.
 */
export const FOLDER_ERROR = {
  /** 이 요청으로 퀴즈(또는 폴더)가 공개된다 — 사용자 확인 후 `confirmSourcePublication: true` 로 재시도. */
  PUBLISH_CONFIRM_REQUIRED: 'QUIZSET_FOLDER_PUBLISH_CONFIRM_REQUIRED',
  /** 비공개 전환은 유료 기능이다. 클라 가드를 통과해도 서버가 최종 판정한다. */
  NO_PREMIUM_PERMISSION: 'NO_PERMISSION_FOR_PREMIUM_FEATURE',
  /**
   * 이름·ID·커서·같은 폴더로 이동 등 잘못된 입력. 개별 '폴더 이동'(`addItem`)은 이미 그 폴더에 있으면 이 코드를 준다.
   * 폴더 수정의 일괄 저장에서는 초안을 잘못 만든 버그 신호다 — 다시 보내지 않는다.
   */
  INVALID_INPUT: 'INVALID_INPUT',
  /**
   * 편집하는 사이 다른 곳(다른 탭 등)에서 퀴즈 위치가 바뀌었다. 일괄 저장은 그 퀴즈를 몰래 가져오지 않고 거절한다.
   * 초안을 고쳐 다시 보내도 같은 충돌이 날 수 있어, 최신 상태로 다시 읽고 처음부터 하게 한다.
   */
  CONCURRENT_UPDATE: 'CONCURRENT_UPDATE_ERROR',
  /** 폴더(또는 대상)가 없다. 고른 사이에 지워졌을 수 있다. */
  NOT_FOUND: 'NOT_FOUND',
  /** 소유권·접근 권한 없음. 남의 폴더를 대상으로 삼은 경우 등. */
  UNAUTHORIZED: 'UNAUTHORIZED',
  /** 원본 퀴즈가 없거나 비공개라 복사할 수 없다. */
  NOT_FOUND_QUIZSET: 'NOT_FOUND_QUIZSET',
} as const;

/** 서버 오류 코드(`ZepQuizApiError.status`). 오류 객체가 아니거나 코드가 없으면 `undefined`. */
export const readApiStatus = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const { status } = error as { status?: unknown };
  return typeof status === 'string' && status ? status : undefined;
};

export const isFolderError = (
  error: unknown,
  code: (typeof FOLDER_ERROR)[keyof typeof FOLDER_ERROR],
): boolean => readApiStatus(error) === code;
